import { sectionRenderer } from './section-renderer';
import { reconcileCartDrawerPanels } from './reconcile-cart-drawer';

let lastCheckedAt = 0;

/**
 * Re-renders the cart when it changed elsewhere while this page sat in the background.
 */
async function revalidateCart() {
  if (document.visibilityState !== 'visible' || Date.now() - lastCheckedAt < 5000) return;
  lastCheckedAt = Date.now();

  // The drawer is the only cart-items-component in the theme — there is no cart page.
  const cartItems = document.querySelector('cart-items-component');
  if (!(cartItems instanceof HTMLElement)) return;

  try {
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { cache: 'no-store' }).then((response) => response.json());
    const signature = `${cart.item_count}:${cart.total_price}:${cart.items.map((item) => `${item.key}@${item.quantity}`).join(',')}`;

    if (signature === cartItems.dataset.cartSignature) return;

    await sectionRenderer.renderSection(cartItems.dataset.sectionId, { cache: false });
    reconcileCartDrawerPanels();
  } catch {
    // Offline or a flaky network on wake-up — skip this revalidation, the next one retries.
  }
}

document.addEventListener('visibilitychange', revalidateCart);
document.addEventListener('resume', revalidateCart);
window.addEventListener('pageshow', (event) => {
  if (event.persisted) revalidateCart();
});
